// Refined and debug-friendly JavaScript for the quiz
const quizData = [
    {
        question: "Tell us what fits with your lifestyle.",
        answers: [
            { text: "Laidback - A ritual that covers the basics", value: "laidback" },
            { text: "The Works - A ritual that’s optimized for results", value: "theworks" },
            { text: "Quick and Easy - A ritual for on-the-go", value: "quick" },
            { text: "Advanced - A ritual for more sophisticated care", value: "advanced" }
        ]
    },
    {
        question: "Tell us about your skin.",
        answers: [
            { text: "Normal - Skin feels balanced with no dry or oily areas", value: "normal" },
            { text: "Dry - Skin feels dehydrated or has areas of roughness", value: "dry" },
            { text: "Oily - Skin has noticeable excess oil and shine, may be prone to breakouts", value: "oily" },
            { text: "Sensitive - Skin is prone to irritation and redness, reacts easily to harsh actives", value: "sensitive" }
        ]
    },
    {
        question: "Tell us about your skin care goals.",
        answers: [
            { text: "Hydrate & Moisturize", value: "hydrate" },
            { text: "Soothe & Balance", value: "soothe" },
            { text: "Prevent Signs of Aging", value: "prevent" },
            { text: "Clear Congested Pores", value: "clear" }
        ]
    },
    {
        question: "Tell us about your skin glow goals.",
        answers: [
            { text: "LIT-FROM WITHIN", value: "lit" },
            { text: "CLASSIC DEW", value: "dew" },
            { text: "GLASS SKIN", value: "glass" }
        ]
    }
];

const resultsMap = {
    "laidback_normal_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_normal_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_normal_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",
    
    "laidback_normal_soothe_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_normal_soothe_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_normal_soothe_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",
    
     "laidback_normal_prevent_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
      "laidback_normal_prevent_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
      "laidback_normal_prevent_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

        "laidback_normal_clear_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
        "laidback_normal_clear_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
        "laidback_normal_clear_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "laidback_dry_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_dry_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_dry_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "laidback_dry_soothe_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_dry_soothe_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_dry_soothe_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "laidback_dry_prevent_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_dry_prevent_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_dry_prevent_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "laidback_dry_clear_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_dry_clear_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_dry_clear_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "laidback_oily_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_oily_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_oily_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "laidback_oily_soothe_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_oily_soothe_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_oily_soothe_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "laidback_oily_prevent_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_oily_prevent_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_oily_prevent_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "laidback_oily_clear_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_oily_clear_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_oily_clear_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

     "laidback_sensitive_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_sensitive_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_sensitive_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "laidback_sensitive_soothe_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_sensitive_soothe_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_sensitive_soothe_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "laidback_sensitive_prevent_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_sensitive_prevent_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_sensitive_prevent_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "laidback_sensitive_clear_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_sensitive_clear_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "laidback_sensitive_clear_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

      "theworks_normal_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
        "theworks_normal_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
        "theworks_normal_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

        "theworks_normal_soothe_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
        "theworks_normal_soothe_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
        "theworks_normal_soothe_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

     "theworks_normal_prevent_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
      "theworks_normal_prevent_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
      "theworks_normal_prevent_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

        "theworks_normal_clear_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
        "theworks_normal_clear_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
        "theworks_normal_clear_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

      "theworks_dry_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_dry_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_dry_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "theworks_dry_soothe_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_dry_soothe_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_dry_soothe_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "theworks_dry_prevent_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_dry_prevent_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_dry_prevent_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "theworks_dry_clear_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_dry_clear_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_dry_clear_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "theworks_oily_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_oily_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_oily_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "theworks_oily_soothe_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_oily_soothe_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_oily_soothe_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "theworks_oily_prevent_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_oily_prevent_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_oily_prevent_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "theworks_oily_clear_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_oily_clear_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_oily_clear_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

     "theworks_sensitive_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_sensitive_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_sensitive_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "theworks_sensitive_soothe_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_sensitive_soothe_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_sensitive_soothe_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "theworks_sensitive_prevent_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_sensitive_prevent_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_sensitive_prevent_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "theworks_sensitive_clear_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_sensitive_clear_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "theworks_sensitive_clear_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

     "quick_normal_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
        "quick_normal_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
        "quick_normal_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

        "quick_normal_soothe_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
        "quick_normal_soothe_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
        "quick_normal_soothe_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

     "quick_normal_prevent_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
      "quick_normal_prevent_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
      "quick_normal_prevent_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

        "quick_normal_clear_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
        "quick_normal_clear_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
        "quick_normal_clear_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

       "quick_dry_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_dry_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_dry_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "quick_dry_soothe_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_dry_soothe_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_dry_soothe_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "quick_dry_prevent_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_dry_prevent_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_dry_prevent_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "quick_dry_clear_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_dry_clear_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_dry_clear_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "quick_oily_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_oily_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_oily_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "quick_oily_soothe_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_oily_soothe_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_oily_soothe_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "quick_oily_prevent_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_oily_prevent_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_oily_prevent_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "quick_oily_clear_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_oily_clear_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_oily_clear_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

     "quick_sensitive_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_sensitive_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_sensitive_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "quick_sensitive_soothe_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_sensitive_soothe_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_sensitive_soothe_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "quick_sensitive_prevent_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_sensitive_prevent_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_sensitive_prevent_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",

    "quick_sensitive_clear_lit": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_sensitive_clear_dew": "https://bestskincareusa.com/products/riman-icd-essential-set",
    "quick_sensitive_clear_glass": "https://bestskincareusa.com/products/riman-icd-essential-set",
    
     "advanced_normal_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
        "advanced_normal_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
        "advanced_normal_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

        "advanced_normal_soothe_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
        "advanced_normal_soothe_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
        "advanced_normal_soothe_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

     "advanced_normal_prevent_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
      "advanced_normal_prevent_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
      "advanced_normal_prevent_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

        "advanced_normal_clear_lit": "https://bestskincareusa.com/products/advanced-riman-ritual",
        "advanced_normal_clear_dew": "https://bestskincareusa.com/products/advanced-riman-ritual",
        "advanced_normal_clear_glass": "https://bestskincareusa.com/products/advanced-riman-ritual",

    "advanced_dry_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_dry_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_dry_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "advanced_dry_soothe_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_dry_soothe_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_dry_soothe_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "advanced_dry_prevent_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_dry_prevent_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_dry_prevent_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "advanced_dry_clear_lit": "https://bestskincareusa.com/products/advanced-riman-ritual",
    "advanced_dry_clear_dew": "https://bestskincareusa.com/products/advanced-riman-ritual",
    "advanced_dry_clear_glass": "https://bestskincareusa.com/products/advanced-riman-ritual",

    "advanced_oily_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_oily_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_oily_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "advanced_oily_soothe_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_oily_soothe_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_oily_soothe_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "advanced_oily_prevent_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_oily_prevent_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_oily_prevent_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

     "advanced_oily_clear_lit": "https://bestskincareusa.com/products/advanced-riman-ritual",
    "advanced_oily_clear_dew": "https://bestskincareusa.com/products/advanced-riman-ritual",
    "advanced_oily_clear_glass": "https://bestskincareusa.com/products/advanced-riman-ritual",

      "advanced_sensitive_hydrate_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_sensitive_hydrate_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_sensitive_hydrate_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "advanced_sensitive_soothe_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_sensitive_soothe_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_sensitive_soothe_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "advanced_sensitive_prevent_lit": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_sensitive_prevent_dew": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",
    "advanced_sensitive_prevent_glass": "https://bestskincareusa.com/products/riman-icd-expert-ritual-set-bestskincareusa-com",

    "advanced_sensitive_clear_lit": "https://bestskincareusa.com/products/advanced-riman-ritual",
    "advanced_sensitive_clear_dew": "https://bestskincareusa.com/products/advanced-riman-ritual",
    "advanced_sensitive_clear_glass": "https://bestskincareusa.com/products/advanced-riman-ritual"
};

let selectedAnswers = [];
let currentQuestion = 0;

const quizArea = document.getElementById('quiz-area');
const resultsContainer = document.getElementById('results-container');
const currentStepElement = document.getElementById('current-step');
const totalStepsElement = document.getElementById('total-steps');

totalStepsElement.textContent = quizData.length;

function loadQuestion() {
    quizArea.innerHTML = "";
    currentStepElement.textContent = currentQuestion + 1;
    const question = quizData[currentQuestion];

    const questionDiv = document.createElement('div');
    questionDiv.classList.add('question');
    questionDiv.textContent = question.question;
    quizArea.appendChild(questionDiv);

    const answerOptionsDiv = document.createElement('div');
    answerOptionsDiv.classList.add('answer-options');

    question.answers.forEach((answer, index) => {
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'question_' + currentQuestion;
        input.value = answer.value;
        input.id = 'answer_' + currentQuestion + '_' + index;

        const label = document.createElement('label');
        label.htmlFor = input.id;
        label.textContent = answer.text;

        answerOptionsDiv.appendChild(input);
        answerOptionsDiv.appendChild(label);
        answerOptionsDiv.appendChild(document.createElement('br'));
    });

    quizArea.appendChild(answerOptionsDiv);

    const button = document.createElement('button');
    button.textContent = currentQuestion < quizData.length - 1 ? "Next" : "Submit";
    button.addEventListener('click', handleButtonClick);
    quizArea.appendChild(button);
}

function handleButtonClick() {
    const selectedOption = document.querySelector(`input[name="question_${currentQuestion}"]:checked`);
    if (!selectedOption) {
        alert("Please select an answer before proceeding.");
        return;
    }

    selectedAnswers.push(selectedOption.value);

    if (currentQuestion < quizData.length - 1) {
        currentQuestion++;
        loadQuestion();
    } else {
        showResults();
    }
}

function showResults() {
    const resultKey = selectedAnswers.join("_");
    let recommendedUrl = resultsMap[resultKey];
console.log("Results container:", resultsContainer);
console.log("Executing showResults()");
console.log("Selected Answers:", selectedAnswers);
console.log("Result Key:", resultKey);
console.log("Recommended URL:", recommendedUrl);

  
    if (!recommendedUrl) {
        recommendedUrl = "https://bestskincareusa.com/products/riman-icd-essential-set"; // Default product fallback
    }
  
   resultsContainer.innerHTML = `
        <p>Your Recommended Ritual is: <a href="${recommendedUrl}" target="_blank">See here</a></p>
        <p><strong>Debug Info:</strong></p>
        <p>Selected Answers: ${selectedAnswers.join(", ")}</p>
        <p>Result Key: ${resultKey}</p>
        <p>Recommended URL: ${recommendedUrl}</p>
    `;
  
    resultsContainer.innerHTML = `<p>Your Recommended Ritual is: <a href="${recommendedUrl}" target="_blank">See here</a></p><p><a href="https://bestskincareusa.com/pages/find-your-skincare-ritual">Restart Quiz</a></p>`;

  console.log("Setting resultsContainer to visible");
resultsContainer.style.display = 'block';
console.log("resultsContainer style:", resultsContainer.style.display);
  
  //resultsContainer.style.display = 'block';
    quizArea.style.display = 'none';

    console.log("Selected Answers:", selectedAnswers);
    console.log("Result Key:", resultKey);
    console.log("Recommended URL:", recommendedUrl);
}

// Initialize quiz
loadQuestion();
